import { BadgeButton } from '../base/badge'

interface Props {
  shift: {
    id: string
    event: {
      description: string
      state: 'pending' | 'cancelled' | 'confirmed'
    }
    shiftRole?: { name: string } | null
  }
}

export const CalendarCard = ({ shift }: Props) => {
  const color = () => {
    switch (shift.event.state) {
      case 'pending': return 'yellow'
      case 'confirmed': return 'green'
      case 'cancelled': return 'red'
    }
  }

  return (
    <>
      <span>
        <BadgeButton color={color()} onClick={() => {}}>
          { shift.event.description }
          { shift.shiftRole?.name ? `(${shift.shiftRole?.name})` : '' }
        </BadgeButton>
      </span>
    </>
  )
}
